import React, { Fragment } from 'react';
import Link from 'next/link';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { Flex, Text, Image, Avatar, useColorMode } from '@chakra-ui/react';
import { getStxAddress } from 'lib/utility';
import { bgColor } from 'config/data';

const dateFormat = 'MMM D [at] h:mma z';

const HistorySection = ({ history, minter }) => {
  const getIcon = (type) => {
    if (type === 'transfer') return '/images/icon-transferred-to.svg';
    if (type === 'listed_in_auction') return '/images/icon-purchased-by.svg';
    if (type === 'purchase') return '/images/icon-purchased-by.svg';
    if (type === 'royalty_payment') return '/images/icon-royalty.svg';
    return '/images/icon-minted-by.svg';
  };
  const { colorMode } = useColorMode();
  return (
    <Fragment>
      <Text fontWeight="bold" mb="20px">
        History
      </Text>

      {history.map((i, index) => {
        const dateEvent = moment(i.created_at).format(dateFormat);
        const tx_id = !isEmpty(i.transaction) ? i.transaction : null;
        const recipient = i.recipient;
        return (
          <Flex
            key={index}
            id="box"
            bg={bgColor[colorMode]}
            boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)"
            p="14px 15px"
            justifyContent="space-between"
            borderRadius={4}
            mb="15px"
          >
            <Flex id="history_info" flex="1" justifyContent="space-between" alignItems="center">
              <Flex id="info" alignItems="center">
                {/* <Avatar bg="#F7F7F7" icon={getIcon(e.type)} mr="10px" w="36px" h="36px" /> */}
                <Image w="36px" h="36px" src={getIcon(i.event_type_label)} alt="" mr="10px" />
                <Flex id="owner_info" fontSize="12px" flexDirection="column">
                  {tx_id ? (
                    <a
                      href={`https://explorer.stacks.co/txid/${tx_id.transaction_id}?chain=${
                        process.env.NEXT_PUBLIC_ENV === 'production' ? 'mainnet' : 'testnet'
                      }`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Text>{i.title}</Text>
                    </a>
                  ) : (
                    <Text>{i.title}</Text>
                  )}

                  {!isEmpty(recipient) ? (
                    <Flex alignItems="center">
                      <Flex pos="relative" id="avatar">
                        <Avatar
                          name={recipient.username}
                          bg="#BC3153"
                          color="#fff"
                          mr="5px"
                          w="18px"
                          h="18px"
                          size="xs"
                        />
                        {recipient?.is_verified && (
                          <Image
                            pos="absolute"
                            bottom="0px"
                            right="2px"
                            w="12px"
                            h="12px"
                            src="/images/icon-verified-icon.svg"
                            alt=""
                          />
                        )}
                      </Flex>
                      <Link href={`/${recipient.username}`}>
                        <a>
                          <Text fontWeight="bold" fontSize="14px">
                            {recipient.username}
                          </Text>
                        </a>
                      </Link>
                    </Flex>
                  ) : (
                    <Flex alignItems="center">
                      <Text fontWeight="bold" fontSize="14px">
                        {i.recipient_wallet?.address && getStxAddress(i.recipient_wallet?.address)}
                      </Text>
                    </Flex>
                  )}

                  {i.user && (
                    <Flex alignItems="center">
                      <Flex pos="relative" id="avatar">
                        <Avatar
                          name={i.user?.username}
                          bg="#BC3153"
                          color="#fff"
                          mr="5px"
                          w="18px"
                          h="18px"
                          size="xs"
                        />
                        {i.user?.is_verified && (
                          <Image
                            pos="absolute"
                            bottom="0px"
                            right="2px"
                            w="12px"
                            h="12px"
                            src="/images/icon-verified-icon.svg"
                            alt=""
                          />
                        )}
                      </Flex>

                      {i.event_type_label === 'mint' ? (
                        <Link href={`/${minter?.username}`}>
                          <a>
                            <Text fontWeight="bold" fontSize="14px">
                              {minter?.username}
                            </Text>
                          </a>
                        </Link>
                      ) : (
                        <Link href={`/${i.user ? i.user?.username : '-'}`}>
                          <a>
                            <Text fontWeight="bold" fontSize="14px">
                              {i.user ? i.user?.username : '-'}
                            </Text>
                          </a>
                        </Link>
                      )}
                    </Flex>
                  )}
                </Flex>
              </Flex>
              <Text fontWeight="500" fontSize="12px">
                {dateEvent}
              </Text>
            </Flex>
          </Flex>
        );
      })}
    </Fragment>
  );
};
export default HistorySection;
